<template>
  <div class="table-pagination">
    <button @click="emitPrevPage">
      &#x3c;
    </button>
    <span class="page-number">{{ page }}</span>
    <button @click="emitNextPage">
      &#x3e;
    </button>
  </div>
</template>
<script>
export default {
  props: ["page"],
  methods: {
    emitPrevPage() {
      this.$emit("onPrev");
    },
    emitNextPage() {
      this.$emit("onNext");
    }
  }
};
</script>
<style lang="scss">
.table-pagination {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 1rem;
}

.page-number {
  width: 40px;
  padding: 0 1rem;
  font-weight: 600;
  font-family: Montserrat-SemiBold;
}

button {
  border: none;
  font-size: 18px;
}
</style>
